import React, { Component } from "react";
import { connect } from "react-redux";
import Pagination from "../../paginator2/Paginator";
import Loading from "../../common/Loading";
import { searchPropResiRents } from "../../../actions/propertyResiAction_Ggn";
import { openModal } from "../../../actions/modalAction";

import { Icon } from "semantic-ui-react";
import PropResiSummary from "./PropResiSummary";

class PropResiRentSearchList extends Component {
  state = {
    pageO: "",
    id: "",
  };
  componentDidMount() {
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };

    const { offsetRR, limitRR } = this.props;

    this.props.searchPropResiRents(values, limitRR, offsetRR);
  }
  handleSearchPropResiRent = () => {
    this.props.openModal("SearchModal", { propRR_Ggn: true });
  };

  //*******************************************************

  handleRefresh = () => {
    const { offsetRR, limitRR } = this.props;
    const values =
      (this.props.form !== undefined && this.props.form.values) || {};

    this.props.searchPropResiRents(values, limitRR, offsetRR);
  };

  //^^^^^^^^^^^^^^^^^^^^^^^^^
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  //*******************************************************

  back = () => {
    const { offsetRR, limitRR } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    if (offsetRR === 0) {
      return;
    }
    this.props.searchPropResiRents(values, limitRR, offsetRR - limitRR);

    window.scroll(0, 0);
  };

  advance = () => {
    const { countRR, offsetRR, limitRR } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    if (offsetRR + limitRR > countRR) {
      return;
    }

    this.props.searchPropResiRents(values, limitRR, offsetRR + limitRR);

    window.scroll(0, 0);
  };
  //***************** */

  handleGoToPage2 = (page) => {
    const { limitRR } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };

    this.props.searchPropResiRents(values, limitRR, (page - 1) * limitRR);
    window.scroll(0, 0);
  };

  renderLoading = () => {
    if (this.props.fetchingRR === true) {
      return <Loading />;
    }
  };

  render() {
    return (
      <div className="maindiv-820 ">
        <div className="card-attached" style={{ textAlign: "center" }}>
          {/**/}
          <div className="border-heading color-CornflowerBlue flex-center pxy-10">
            <div
              style={{ flex: "15%" }}
              onClick={this.handleSearchPropResiRent}
            >
              <span className="tag-button">
                {" "}
                <Icon name="search" />
              </span>
            </div>

            <div
              style={{ display: "flex", flex: "80%", justifyContent: "center" }}
            >
              <div className="font-20B ml-05 color-head-prop">
                {this.props.countRR} Residential Property For Rent in{" "}
                {this.props.city}
              </div>
            </div>
          </div>
          {/**/}
        </div>
        {/*  */}

        <div>
          {this.renderLoading()}

          {this.props.propresisRR.map((item) => (
            <PropResiSummary
              handleRefresh={this.handleRefresh}
              key={item._id}
              propresi={item}
            />
          ))}
        </div>

        <div className="card-attached flex-center ">
          {this.props.propresisRR !== undefined &&
            this.props.propresisRR.length && (
              <Pagination
                changePage={this.handleGoToPage2}
                advance={this.advance}
                back={this.back}
                page={
                  this.props.offsetRR === 0
                    ? 1
                    : Math.ceil(this.props.offsetRR / this.props.limitRR + 1)
                }
                pages={Math.ceil(this.props.countRR / this.props.limitRR)}
              />
            )}
        </div>
        {/*  */}

        <br />
        <br />
      </div>
    );

    //@@@@
  }
}

const mapStateToProps = ({ ggn_resi_property, auth, form }) => {
  const {city, fetchingRR, limitRR, offsetRR, countRR } = ggn_resi_property;

  return {
    city,
    fetchingRR,
    limitRR,
    offsetRR,
    countRR,
    form: form.PropResiRentSearch,
    propresisRR: ggn_resi_property.propresisRR,
    userA: auth.userA,
  };
};

export default connect(mapStateToProps, { searchPropResiRents, openModal })(
  PropResiRentSearchList
);
